<template>
  <f7-list-item class="activity-list-item"
                v-bind:class="{
                  'last': is_last,
                  'first': is_first,
                }"
                :link="navigateTo"
                swipeout
                @swipeout:deleted="onDeleted"
                :checkbox="editable"
                @change="onChange($event)"
                :sortable="sortable"
                :checked="checked"
                :prevent-router="true"
                @click="onClickListItem"

                @swipeout:open="$emit('swipeout:open')"
                @swipeout:close="$emit('swipeout:close')"
                @swipeout="$emit('swipeout', $event)"
  >
    <template v-slot:media>
<!--      <img src="/static/images/muscle-groups/chest.svg" style="height: 42px;"/>-->
      <div class="muscle-image-container d-flex justify-content-center px-3" style="position:relative;">
        <img class="muscle-image" :src="rootUrl + '/static/images/muscles/' + image" alt="" v-for="image in muscle_group_images">
      </div>
      <f7-icon v-if="finished" f7="checkmark_seal_fill"
               style="position:relative; left: -24px; top:10px; width:0px;">
      </f7-icon>
    </template>
    <template v-slot:inner>
      <div class="w-100">
        <f7-row no-gap>
          <f7-col>
            <div class="activity-name">
              {{ activity.name }}
              <activity-notes-button :activity="activity"></activity-notes-button>
            </div>
          </f7-col>
        </f7-row>
        <div class="rep-set-summary">
          <div class="rep-summary" v-for="(rep_set, index) in activity.rep_sets"
               v-bind:class="{'font-italic': isFinishedRep(index), 'text-brand-shade': isFinishedRep(index)}">
            {{ rep_set.reps }}x<br/>
            {{ rep_set.weight }}
          </div>
        </div>
      </div>
    </template>
    <!--    <div slot="inner">Inner End</div>-->
    <!--    <div slot="before-title">Before Title</div>-->
    <!--    <div slot="after-title">After Title</div>-->

    <f7-swipeout-actions left>
      <f7-swipeout-button style="padding-right: 20px;" color="white" @click.stop="showWeightCalculator = true" :close="true">
        <img src="/static/images/icons/weight-icon-001-brand7.svg" style="height: 40px; opacity: 0.7;">
      </f7-swipeout-button>
    </f7-swipeout-actions>
    <f7-swipeout-actions right>
      <f7-swipeout-button color="black" @click.stop="clearRepSets()" :close="true" v-if="activity.finished">
        <f7-icon f7="xmark"></f7-icon>
      </f7-swipeout-button>
      <f7-swipeout-button color="black" @click.stop="sets_finished = sets_finished + 1" :close="true" v-else>
        <f7-icon f7="checkmark_alt"></f7-icon>
      </f7-swipeout-button>
      <!--      <f7-swipeout-button delete confirm-text="Are you sure you want to delete this item?">-->
      <!--        Delete-->
      <!--      </f7-swipeout-button>-->
    </f7-swipeout-actions>

    <activity-weight-calculator-sheet-modal
      :show="showWeightCalculator"
      @closed="showWeightCalculator = false"

      :activity="activity">
    </activity-weight-calculator-sheet-modal>

  </f7-list-item>
</template>

<script>

  import ActivityNotesButton from "../activities/ActivityNotesButton.vue";
  import ActivityWeightCalculatorSheetModal from "../activities/ActivityWeightCalculatorSheetModal.vue";
  import utility from "../../js/utility";
  import { f7, f7ready, theme } from 'framework7-vue';

  export default {
    components: {
      ActivityWeightCalculatorSheetModal,
      ActivityNotesButton,
    },

    props: {
      'training_session': '',
      'activity_id': '',
      'editable': '',
      'sortable': '',
      'active_navigation': {default: true},
      'clear_checkbox': {default: 0},
      'is_last': {default: false},
      'is_first': {default: false},
      'f7router': {required: true},
    },

    mixins: [],

    data: function () {
      return {
        showWeightCalculator: false,
        checked: false,
      };
    },

    computed: {
      rootUrl() {
        return import.meta.env.PG_ROOT_URL;
      },
      user_id() {
        return this.$store.state.current_user.data.id;
      },
      finished() {
        return this.activity.finished;
      },
      navigateTo() {
        if (!this.editable && this.active_navigation) {
          return '/training-sessions/' + this.training_session.id + '/activities/' + this.activity.id + '/';
        }
        return false;
      },
      activity() {
        return this.$store.getters['activities/find'](this.activity_id);
      },
      // By sets_finished, we can allow the user to check off set by set to track their progress.
      sets_finished: {
        get() {
          if(this.activity) {
            return this.activity.sets_finished;
          }
          return 0;
        },
        set(value) {
          this.$store.dispatch('activities/update', {
            user_id: this.user_id,
            activity_id: this.activity.id,
            training_session_id: this.training_session.id,
            sets_finished: value,
          });
        }
      },
      muscle_group_images() {
        let images = [];
        if(typeof this.activity.muscle_groups === 'undefined') {
          return images;
        }
        this.activity.muscle_groups.forEach(muscle_group => {
          images.push(muscle_group.toLowerCase() + '.svg');
        })
        return images;
      },
    },

    created() {
      //
    },

    mounted() {
      //
    },

    methods: {
      onTapHold() {
        console.log('tapHold');
      },
      onDeleted() {
        this.$store.dispatch('activities/destroy', {
          user_id: this.user_id,
          training_session_id: this.training_session.id,
          activity_ids: [this.activity.id],
        });
      },
      updateFinished(value) {
        this.$store.dispatch('activities/update', {
          user_id: this.user_id,
          activity_id: this.activity.id,
          training_session_id: this.training_session.id,
          finished: value,
        });
      },
      onChange(event) {
        this.checked = event.target.checked;
      },
      isFinishedRep(index) {
        return (index + 1) <= this.sets_finished;
      },
      onClickListItem() {
        if (!this.editable) {
          this.f7router.navigate(this.navigateTo);
          // f7.views.main.router.navigate(this.navigateTo);
        }
      },
      clearRepSets() {
        this.$store.dispatch('activities/update', {
          user_id: this.user_id,
          activity_id: this.activity.id,
          training_session_id: this.training_session.id,
          sets_finished: 0,
          finished: 0,
        });
      }
    },

    watch: {
      clear_checkbox() {
        this.checked = false;
      },
      sets_finished(sets_finished) {
        let icon = utility.get_random_from_array(['airplane', 'bolt_fill', 'burst', 'burn', 'cat', 'checkmark_seal', 'checkmark_shield_fill', 'chevron_right_2', 'control', 'dog', 'drop', 'exclamationmark_bubble_fill', 'flame', 'flame_fill', 'gift_fill', 'gift', 'hammer_fill', 'hand_point_right_fill', 'hand_raised', 'hand_raised_fill', 'hand_thumbsup', 'hare', 'heart', 'heart_circle', 'heart_circle_fill', 'heart_fill']);
        let string = utility.get_random_from_array(['Lekker bezig!', 'Hoppa!', 'En klaar!', 'Check', 'Top!']);
        if (sets_finished >= this.activity.rep_sets.length) {
          this.$store.dispatch('notifications/addCenterNotification', {
            icon: icon,
            message: string,
            hide_after: 2000,
          });
          this.updateFinished(1);
        }
      },
    }
  };
</script>
<style lang="scss">
  .rep-set-summary {
    display: flex;
    gap: 16px;
    font-size: 0.8em;
  }

  .rep-summary {
    overflow: hidden;
  }

  .activity-list-item {
    .activity-notes-button {
      i.icon {
        font-size: 20px;
        top: -2px;
      }
    }

    .muscle-image-container {
      height: 56px;
    }
    .muscle-image {
      position:absolute;
      height: 56px;
      top:4px;
    }
  }
</style>
